module.exports = __webpack_public_path__ + "static/media/img-1.acf5bd0c.jpg";